import { forwardRef } from '@chakra-ui/system';

import Text, { type TextProps } from 'components/_core/Text';

const AccordionText = forwardRef<TextProps, 'p'>((props, ref) => (
  <Text ref={ref} variant="light" {...props} />
));

export default AccordionText;
